import React, { Component } from 'react';

class CodingLangs extends Component {
    render() {
        return (
            <div className="codingLang">
            <h1>
            <span>____________________</span>
            <div className="message" >
            <div >JavaScript</div><br></br>
            <div >React</div><br></br>
            <div >Express</div><br></br>
            <div >PostgreSQL</div><br></br>
            <div >Node.js</div><br></br>
            <div >HTML&CSS</div><br></br>
            <div >Git(GitHub)</div><br></br>
            <div >CRUD apps</div><br></br>
            <div >REST API</div><br></br>
            <div >CSS(flexbox)</div>
            </div>
            </h1>
            </div>
          
            )}
}
export default CodingLangs